import { render, staticRenderFns } from "./RandomTextView.vue?vue&type=template&id=752efb6c&scoped=true"
import script from "./RandomTextView.vue?vue&type=script&lang=js"
export * from "./RandomTextView.vue?vue&type=script&lang=js"
import style0 from "./RandomTextView.vue?vue&type=style&index=0&id=752efb6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752efb6c",
  null
  
)

export default component.exports